import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs';
import { HttpError } from '@app-shared-root/interceptor/http.error';
import { LoginService } from '../../services/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  // Regular dep. injection doesn't work in HttpInterceptor due to a framework issue (as of angular@5.2.9),
  // use Injector directly (don't forget to add @Injectable() decorator to class).
  constructor(private _injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const logFormat = 'background: maroon; color: white';

    return next.handle(req)
      .pipe(
        tap(event => {
        }, exception => {
          const snackBar = this._injector.get(MatSnackBar);
          if (exception instanceof HttpErrorResponse) {
            switch (exception.status) {

              case HttpError.BadRequest:
                console.error('%c Bad Request 400', logFormat);
                break;

              case HttpError.Unauthorized:
                console.error('%c Unauthorized 401', logFormat);
                // window.location.href = '/login' + window.location.hash;
                const loginService = this._injector.get(LoginService);
                if (loginService) {
                  loginService.login();
                }
                break;

              case HttpError.NotFound:
                //show error snackbar message
                console.error('%c Not Found 404', logFormat);
                snackBar.open(
                  exception.error && (exception.error.message ? exception.error.message : exception.statusText),
                  'Sluiten',
                  { duration: 5000, panelClass: ['error-snackbar'] }
                );
                break;

              case HttpError.TimeOut:
                // Handled in AnalyticsExceptionHandler
                console.error('%c TimeOut 408', logFormat);
                break;

              case HttpError.Forbidden:
                console.error('%c Forbidden 403', logFormat);
                break;

              case HttpError.InternalServerError:
                console.error('%c bad 500', logFormat);
                snackBar.open(
                  exception.error && (exception.error.message ? exception.error.message : exception.statusText),
                  'Sluiten',
                  { duration: 5000, panelClass: ['error-snackbar'] }
                );
                break;
            }
          }
        })
      );
  }
}
